import React, { Component } from 'react';

import Wrapper from './WrapperComponent'
import { actions } from '../../wrapper'
import { connect } from 'react-redux'

class Wrapped extends Component {    
    componentWillMount() {
    }    

    componentWillUnmount() {
    }    

    render() {
        return (
            <Wrapper {...this.props}/>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.waas.wrapper.user,
        accounts: state.waas.wrapper.accounts,  
        currAccount: state.waas.wrapper.currentAccountIdx,
        configurationUpdating: state.waas.wrapper.configurationUpdating,
        updateTime: state.waas.wrapper.settings.update_time,          
        updateError: state.waas.wrapper.problematic, 
        serial: state.waas.wrapper.serial,
        build: state.waas.wrapper.build
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetchAccounts: () => {
            dispatch(actions.fetchAccounts())
        },        
        switchAccount: (accountId) => {
            dispatch(actions.switchAccount(accountId))
        },
        logout: () => {            
            dispatch(actions.logout())
        },              
        stopUpdateTimer: () => {
            dispatch(actions.stopUpdateTimer());
        },
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Wrapped)
